import { EntityModel } from "@jugl-web/rest-api";
import { Avatar, PlainButton, Menu } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import { NotRemovableReasonHint } from "@web-src/modules/entities/components/NotRemovableReasonHint";
import { useEntityRemovability } from "@web-src/modules/entities/hooks/useEntityRemovability";
import React from "react";
import { ReactComponent as AdminIcon } from "./assets/admin.svg";
import { ReactComponent as OptionsIcon } from "./assets/options.svg";
import { ReactComponent as TrashIcon } from "./assets/trash.svg";

export const EntityTile: React.FC<{
  entity: EntityModel;
  onDelete: () => void;
  onManageAdmins: () => void;
}> = ({ entity, onManageAdmins, onDelete }) => {
  const { t } = useTranslations();

  const { notRemovable, notRemovableReason } = useEntityRemovability(
    entity.type === "cx" ? entity.id : undefined
  );

  return (
    <div className="flex items-center justify-between rounded-2xl bg-grey-100 px-4 py-3">
      <div className="flex items-center gap-3">
        <Avatar imageUrl={entity.logoImg} username={entity.name} size="md" />
        <div className="flex flex-col gap-0.5 text-left font-secondary text-sm leading-[21px] tracking-[0.14px]">
          <span className="font-medium text-dark">{entity.name}</span>
          <span className="text-[#828282]">
            {t(
              {
                id: "manage-workspace-admins-dialog-component.members-count",
                defaultMessage:
                  "{count} {count, plural, one {Member} other {Members}}",
              },
              { count: entity.userCount }
            )}
          </span>
        </div>
      </div>
      <Menu
        placement="bottom-end"
        autoPosition
        autoClose
        sections={[
          [
            {
              id: "manage-admins",
              label: t({
                id: "manage-workspace-admins-dialog-component.manage-admins",
                defaultMessage: "Manage Admins",
              }),
              icon: <AdminIcon />,
              onSelect: onManageAdmins,
            },
            {
              id: "delete-workspace",
              label: t({
                id: "manage-workspace-admins-dialog-component.delete-workspace",
                defaultMessage: "Delete Workspace",
              }),
              icon: <TrashIcon className={notRemovable ? "opacity-25" : ""} />,
              endSlot: notRemovableReason ? (
                <NotRemovableReasonHint reason={notRemovableReason} />
              ) : undefined,
              labelClassName: notRemovable ? "opacity-25" : undefined,
              onSelect: () => {
                if (notRemovable) {
                  return;
                }
                onDelete();
              },
            },
          ],
        ]}
        renderTrigger={({ Trigger, triggerRef }) => (
          <Trigger as={PlainButton} ref={triggerRef}>
            <OptionsIcon />
          </Trigger>
        )}
      />
    </div>
  );
};
